import React from 'react';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';

type PopulateUrlProps = {
  url: string;
  label: string;
};

export default function PopulateUrl({ url, label }: PopulateUrlProps) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="group inline-flex shrink-0 items-center gap-0.5 text-xs font-semibold text-blue-600 hover:text-blue-600 hover:underline"
    >
      {label}
      <OpenInNewRoundedIcon className="!h-3 !w-3 text-blue-600 group-hover:text-blue-600" />
    </a>
  );
}
